const displayGameId = (gameId) => {
  if (gameId >= 10000) {
    return gameId - 10000;
  }
  return gameId;
};

export { displayGameId };
